// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_w4k","footer":"styles_footer__3KGOF"};